const go = (url,redirect)=>{
    if(typeof url !== 'string') return console.log("url is not string");
    // var wwwUrl;
    // if(url.slice(0,4) == "http") {
    //     wwwUrl = url;
    // }
    url = url.split("?");
    var path = url[0];
    path = path == "/" ? "index" : path;
    if ("undefined" != typeof wx && wx.getSystemInfoSync) {
        path = "/pages/" + path + "/index";
        if(url.length > 1) path += `?${url[1]}`;
        if(path.indexOf("/pages/index/index") > -1) return wx.reLaunch({url: `${path}`});
        if(redirect) return wx.redirectTo({url: `${path}`});
        wx.navigateTo({url: `${path}`});
    } else {
        path = path + ".html";
        if(url.length > 1) path += `?${url[1]}`;
        if(redirect) return location.replace(path);
        location.href = path;
    }
}

const push = (obj = {})=>{
    var { type, url } = obj;
    switch (type) {
        case "page":
            go(`page?pageid=${url}`);
            break;
        case "form":
            go(`form?formid=${url}`);
            break;
        case "product":
            go(`product?productid=${url}`);
            break;
        default:
            if(!!type) console.log(type+"暂时不支持");
            break;
    }
}

const back = ()=>{
    if ("undefined" != typeof wx && wx.getSystemInfoSync) {
        wx.navigateBack({});
    } else {
        window.history.back();
    }
}

export default {
    go,
    push,
    back
}